import { initializeApp } from 'firebase/app';
import { getFirestore, collection, collectionGroup, addDoc, getDocs, getDoc, onSnapshot, deleteDoc, doc, updateDoc, setDoc, serverTimestamp, query, where, orderBy, startAt, endAt, limit, runTransaction, writeBatch, arrayUnion, arrayRemove } from 'firebase/firestore';
import { getAuth, onAuthStateChanged, signInWithEmailAndPassword, createUserWithEmailAndPassword, signOut, sendPasswordResetEmail, updatePassword, updateProfile, reauthenticateWithCredential, EmailAuthProvider, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { getFunctions, httpsCallable } from 'firebase/functions';

const firebaseConfig = {
    apiKey: "AIzaSyAf60Xd5zZWlOsgjugOQFmNqKQoPoPCxTE",
    authDomain: "nogometnaapp.firebaseapp.com",
    projectId: "nogometnaapp",
    storageBucket: "nogometnaapp.firebasestorage.app",
    messagingSenderId: "220317980061",
    appId: "1:220317980061:web:c8874aa5e888fb8a7b8b74"
  };

// Inicijalizacija Firebase-a
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
setPersistence(auth, browserLocalPersistence).catch(() => {});
const functions = getFunctions(app);

export { db, auth, functions, httpsCallable, collection, collectionGroup, addDoc, getDocs, getDoc, onSnapshot, deleteDoc, doc, updateDoc, onAuthStateChanged, signInWithEmailAndPassword, createUserWithEmailAndPassword, signOut, sendPasswordResetEmail, updatePassword, updateProfile, reauthenticateWithCredential, EmailAuthProvider, setDoc, serverTimestamp, query, where, orderBy, startAt, endAt, limit, runTransaction, writeBatch, arrayUnion, arrayRemove };
